import React, { useEffect, useState } from "react";

import DashboardCards from "../../../components/dashboard/dashboardCards";
import PieChart from "../../../components/dashboard/pieChart";
import SixMonthBotRecord from "../../../components/dashboard/SixMonthBotRecord";
import ConverationsGraph from "../../../components/dashboard/conversationsGraph";
import DashboardFilters from "../../../components/dashboard/DashboardFilters";
import { useQuery } from "@apollo/client";

import { useStateWithCallback } from "../../../utils/hooks/useStateWithCallback";
import { IBotAnalyticsFilterInput } from "../../../utils/interfaces/IBotAnalyticsFilterInput";
import LoadingSpinner from "../../../components/LoadingSpinner";
import {
  GET_BOT_ANALYTICS,
  GET_GRAPH_ANALYTICS,
  GET_ALL_APPLICATION_IDS,
} from "../../../graphql/query";
import StarRating from "../../../components/dashboard/starRating";

const Dashboard: React.FC = () => {
  const [botAnalyticsFilterInput, setBotAnalyticsFilterInput] =
    useStateWithCallback<IBotAnalyticsFilterInput>({
      applicationIds: [0], // will come dynamically from API
      startDate: new Date(new Date().setDate(new Date().getDate() - 30))
        .toISOString()
        .split("T")[0],
      endDate: new Date().toISOString().split("T")[0],
    });

  const [graphAnalyticsFilterInput, setGraphAnalyticsFilterInput] =
    useStateWithCallback<IBotAnalyticsFilterInput>({
      applicationIds: botAnalyticsFilterInput.applicationIds,
      startDate: botAnalyticsFilterInput.startDate,
      endDate: botAnalyticsFilterInput.endDate,
      groupBy: "date",
    });
  const [dropDownTitle, setDropDowntitle] = useState<
    "Monthly" | "Weekly" | "Daily"
  >("Daily");
  const [isLoading, setIsLoading] = useState(false);

  const {
    loading,
    error,
    data,
    refetch: refetchBotAnalytics,
  } = useQuery(GET_BOT_ANALYTICS, {
    variables: {
      input: {
        ...botAnalyticsFilterInput,
      },
    },
    context: {
      headers: {
        "access-control-allow-methods": "Dashboard",
      },
    },
  });

  const {
    loading: loading2,
    error: error2,
    data: data2,
    refetch: refetchGraphAnalytics,
  } = useQuery(GET_GRAPH_ANALYTICS, {
    variables: {
      input: {
        ...graphAnalyticsFilterInput,
      },
    },
    context: {
      headers: {
        "access-control-allow-methods": "Dashboard",
      },
    },
  });

  const {
    loading: loading3,
    error: error3,
    data: data3,
  } = useQuery(GET_ALL_APPLICATION_IDS, {
    variables: {
      input: {
        appIDString: null,
      },
    },
    context: {
      headers: {
        "access-control-allow-methods": "Dashboard",
      },
    },
  });

  useEffect(() => {
    refetchGraphAnalytics({
      input: {
        ...graphAnalyticsFilterInput,
        applicationIds: botAnalyticsFilterInput.applicationIds,
        startDate: botAnalyticsFilterInput.startDate,
        endDate: botAnalyticsFilterInput.endDate,
      },
      context: {
        headers: {
          "access-control-allow-methods": "Dashboard",
        },
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [graphAnalyticsFilterInput, botAnalyticsFilterInput]);

  if (error) return <h1>{error.message}</h1>;
  if (error2) return <h1>{error2.message}</h1>;
  if (error3) return <h1>{error3.message}</h1>;
  if (!!loading3) {
    return (
      <>
        <LoadingSpinner />
      </>
    );
  }

  //---- Begin botAnalyticsFilterInput---------//

  return (
    <>
      <div className="card-header align-items-center py-1 my-1 gap-2 gap-md-5">
        <div id="kt_app_toolbar" className="app-toolbar py-3">
          <div
            id="kt_app_toolbar_container"
            className="app-container ms-4 me-4 mb-4 d-flex flex-stack"
          >
            <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
              <h2>Chat dashboard</h2>
            </div>
            <div>
              <DashboardFilters
                className="mb-4 h-auto"
                botAnalyticsFilterInput={botAnalyticsFilterInput}
                setBotAnalyticsFilterInput={setBotAnalyticsFilterInput}
                allApplicationIds={data3}
                setGraphAnalyticsFilterInput={setGraphAnalyticsFilterInput}
              />
            </div>
          </div>

          {data3.allApplicationId.length < 1 ? (
            <div className="h-50 d-flex align-items-center justify-content-center fs-1">
              No Chatbot found related to this business account
            </div>
          ) : (
            <>
              {/* End :: Dashboard filter  */}
              {!!loading || !!isLoading ? (
                <div className="h-100 d-flex align-items-center justify-content-center ">
                  <LoadingSpinner />
                </div>
              ) : (
                <>
                  {/* begin::Row */}
                  <div className="row gy-2 g-xl-12">
                    <div className="col  ">
                      <DashboardCards
                        className="card-xl-stretch mb-xl-1  "
                        title="Total Bot Conversations"
                        description={
                          data.botAnalytics.data.totalBotConversations
                        }
                      />
                    </div>

                    <div className="col">
                      <DashboardCards
                        className="card-xl-stretch mb-xl-1"
                        title="Unique Bot Visits"
                        description={data.botAnalytics.data.uniqueChats}
                      />
                    </div>

                    <div className="col">
                      <DashboardCards
                        className="card-xl-stretch mb-xl-1"
                        title="Bot To Human Handoff Rate"
                        description={
                          data.botAnalytics.data.botToHumanHandOffRatio
                        }
                      />
                    </div>

                    {/* <div className='col'>
                  <DashboardCards
                    className='card-xl-stretch mb-xl-1'
                    title=' Average Time Taken(Min)'
                    description={
                      data.botAnalytics[0].avgTimeTakenInMins === null
                        ? 0
                        : data.botAnalytics[0].avgTimeTakenInMins.toFixed(1)
                    }
                  />
                </div> */}
                    <div className="col">
                      <DashboardCards
                        className="card-xl-stretch mb-xl-1"
                        title="Total Bot Visits"
                        description={data.botAnalytics.data.botVisits}
                      />
                    </div>
                    <div className="col">
                      <DashboardCards
                        className="card-xl-stretch mb-xl-1"
                        title="Average Bot Conversations"
                        description={
                          data.botAnalytics.data.botConversationRatio
                        }
                      />
                    </div>
                  </div>
                  {/* end::Row */}
                  <br></br>

                  {/* begin::Row */}
                  <div className="row gy-5 gx-xxl-12">
                    <div className="col-xxl-8">
                      <ConverationsGraph
                        className="card-xxl-stretch mb-5 mb-xxl-8"
                        graphAnalyticsFilterInput={graphAnalyticsFilterInput}
                        setGraphAnalyticsFilterInput={
                          setGraphAnalyticsFilterInput
                        }
                        graphAnalyticsData={data2}
                        isLoading={loading2}
                        dropDownTitle={dropDownTitle}
                        setDropDowntitle={setDropDowntitle}
                        botAnalyticsFilterInput={botAnalyticsFilterInput}
                      />
                    </div>
                    <div className="col-xxl-4">
                      <PieChart
                        className="card-xl-stretch mb-xl-2"
                        overviewTotal={[
                          data.botAnalytics.data.assignedChats,
                          data.botAnalytics.data.unassignedChats,
                        ]}
                      />
                    </div>
                  </div>
                  {/* end::Row */}

                  {/* begin::Row */}
                  <div className="row gy-5 gx-xxl-12">
                    <div className="row gy-5 gx-xxl-12">
                      <div className="col-xxl-8">
                        <SixMonthBotRecord
                          className="card-xxl-stretch mb-5 mb-xxl-8"
                          graphAnalyticsFilterInput={graphAnalyticsFilterInput}
                          setIsLoading={setIsLoading}
                        />
                      </div>
                      <div className="col-xxl-4">
                        <StarRating
                          className="card-xxl-stretch mb-5 mb-xxl-8"
                          ratingdata={data.botAnalytics.data.ratings}
                        />
                      </div>{" "}
                      *
                    </div>
                  </div>
                  {/* end::Row */}
                  {/* begin::Row */}
                  <div className="row gy-3 g-xl-8">
                    <div></div>
                  </div>
                </>
              )}
              {/* end::Row */}
            </>
          )}
        </div>
      </div>{" "}
    </>
  );
};

export default Dashboard;
